export const role = {
    superAdmin: 'superAdmin',
    admin: 'admin',
    hr: 'hr',
    security: 'security',
    guard: 'guard',
    receptionist: 'receptionist',
}
export const status = {
    pending: 'pending',
    Pending: 'Pending',
    approved: 'approved',
    Approved: 'Approved',
    rejected: 'rejected',
    Rejected: 'Rejected',
    checkIn: 'checkIn',
    completed: 'completed',
    Completed: 'Completed',
    active: 'active',
    Active: 'Active',
    InActive: 'In Active',
    inActive: 'In Active',
    expired: 'expired',
    Expired: 'Expired',
    cancelled: 'cancelled',
    Cancelled: 'Cancelled',
    blocked: 'blocked',
    Blocked: 'Blocked',
    In: 'In',
    in: 'in',
    Out: 'Out',
    out: 'out',
    succeeded: 'succeeded'
}
export const entryType = {
    visitor: 'visitor',
    Visitor: 'Visitor',
    appointment: 'appointment',
    Appointment: 'Appointment',
    pass: 'pass',
    Pass: 'Pass'
}
export const access = {
    '1stFloor': '1stFloor',
    '2ndFloor': '2ndFloor',
    'fullAccess': 'fullAccess'
}
export const message = {
    invalidCredentials: 'Invalid Credentials'
}